module.exports = __webpack_public_path__ + "img/HEAT-alt.0e153f21.svg";